import { render, staticRenderFns } from "./baleno.vue?vue&type=template&id=557ab0f8&"
import script from "./baleno.vue?vue&type=script&lang=ts&"
export * from "./baleno.vue?vue&type=script&lang=ts&"
import style0 from "./baleno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports